import * as React from "react";
import UnderConstruction from "../../../../../shared/presentations/UnderConstruction";

const DashboardPage = () => {
  return (
    <div>
      <UnderConstruction></UnderConstruction>
    </div>
  );
};

export default DashboardPage;
